import type { PcmCaptureStats } from '../workers/messages-types';

// Provisional value; tuned against the observed baseline in ENG-4827.
export const STARVED_QUANTA_ALERT_THRESHOLD = 0.3;

// Web Audio render quantum — every worklet process() call covers exactly
// 128 frames (spec constant, mirrored by QUANTUM in pcm-capture.worklet.ts).
export const QUANTUM_FRAMES = 128;

/**
 * Cumulative capture-side progress derived from the worklet's counters.
 * `capturedSeconds` counts only non-empty quanta — audio the worklet actually
 * buffered — so a running-but-starved audio graph reads as no progress.
 * [ENG-5045]
 */
export type CaptureProgress = PcmCaptureStats & {
  capturedSeconds: number;
};

export function toCaptureProgress(
  stats: PcmCaptureStats,
  sampleRateHz: number,
): CaptureProgress {
  return {
    ...stats,
    capturedSeconds:
      ((stats.totalQuanta - stats.emptyQuanta) * QUANTUM_FRAMES) / sampleRateHz,
  };
}

export function starvedFraction(stats: PcmCaptureStats): number {
  if (stats.totalQuanta === 0) return 0;
  return stats.emptyQuanta / stats.totalQuanta;
}

export function isCaptureShortfall(stats: PcmCaptureStats): boolean {
  return (
    stats.totalQuanta > 0 &&
    starvedFraction(stats) > STARVED_QUANTA_ALERT_THRESHOLD
  );
}
